<template>
	<v-autocomplete
		:item-text="ownerText"
		label="Ingrese razón social o ruc"
		dense
		outlined
		hide-details
		persistent-placeholder
		clearable
		:item-value="entry ? entry : 'document'"
		:value="owner"
		:items="owners"
		:loading="loading"
		@input="(v) => setValue(v)"
	>
	</v-autocomplete>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
	name: 'SearchDocument',
	props: ['value', 'entry', 'ownerType'],
	data: () => ({
		timeout: null,
		loading: false,
		input: null,
		dialog: false,
	}),
	async created() {
		this.loading = true;
		await this.listOwners(this.ownerType ? { type: this.ownerType } : undefined);
		this.loading = false;
	},
	computed: {
		...mapState('owner', ['owners']),
		owner: {
			get() {
				return this.value || null;
			},
			set(value) {
				this.$emit('input', value);
			},
		},
	},

	watch: {
		async ownerType(newVal, oldVal) {
			if (newVal === oldVal) return;
			this.loading = true;
			await this.listOwners(newVal ? { type: newVal } : undefined);
			this.loading = false;
		},
	},
	methods: {
		...mapActions('owner', ['listOwners']),
		listenSearch(value) {
			clearTimeout(this.timeout);
			if ((value || '').length > 0 || value == '') {
				this.timeout = setTimeout(async () => {
					this.loading = true;
					await this.listOwners({ q: value, ...(this.ownerType ? { type: this.ownerType } : {}) });
					this.loading = false;
					clearTimeout(this.timeout);
				}, 800);
			}
		},
		ownerText(item) {
			return item.document ? `${item.name} - ${item.document}` : item.name;
		},
		setValue(value) {
			this.$emit('input', value);
		},
		async setOwner(text) {
			if (text) {
				this.setValue(text);
				await this.listOwners({ q: text, ...(this.ownerType ? { type: this.ownerType } : {}) });
			}
		},
	},
	destroyed() {
		clearTimeout(this.timeout);
	},
	components: {},
};
</script>
